import { NotificationTypeEnum } from 'Components/designSystem/components/notification/Notification';
import { showToast, ToastOptions } from 'modules/ToastManager';
import { useCallback } from 'react';

import useAppDispatch from './useAppDispatch';

const SUCCESS_NOTIFICATION_DURATION = 5000;
const ERROR_NOTIFICATION_DURATION = 5000;
const INFO_NOTIFICATION_DURATION = 5000;

export default function useToast() {
    const dispatch = useAppDispatch();

    const show = useCallback((toast: ToastOptions) => {
        dispatch(showToast({ toast }));
    }, [ dispatch ]);

    const showSuccess = useCallback((text: string, id: string) => {
        const toast: ToastOptions = {
            id,
            type: NotificationTypeEnum.Success,
            description: text,
            duration: SUCCESS_NOTIFICATION_DURATION
        };

        show(toast);
    }, [ show ]);

    const showError = useCallback((text: string, id: string) => {
        const toast: ToastOptions = {
            id,
            type: NotificationTypeEnum.Error,
            description: text,
            duration: ERROR_NOTIFICATION_DURATION
        };

        show(toast);
    }, [ show ]);

    const showInfo = useCallback((text: string, id: string) => {
        const toast: ToastOptions = {
            id,
            type: NotificationTypeEnum.Information,
            description: text,
            duration: INFO_NOTIFICATION_DURATION
        };

        show(toast);
    }, [ show ]);

    return { show, showSuccess, showError, showInfo };
}
